import SuggestionsPage from '../en/suggestions';
export default SuggestionsPage;